import { z } from "zod";
export const userStatusEnum = z.enum([
    "ACTIVE",
    "SUSPENDED",
    "INVITED",
    "DISABLED",
]);
export const boUserSchema = z.object({
    id: z.number(),
    email: z.string(),
    fullName: z.string(),
    status: userStatusEnum,
    mfaEnabled: z.boolean(),
    ginaUsuarioId: z.number().nullable(),
    ginaIdcompany: z.number().nullable(),
    roles: z.array(z.string()),
    lastLoginAt: z.string().nullable(),
    createdAt: z.string(),
});
export const createUserSchema = z.object({
    email: z.string().email(),
    fullName: z.string().min(1).max(150),
    password: z.string().min(12).max(255),
    roles: z.array(z.string()).min(1),
    ginaIdcompany: z.number().int().positive().optional(),
    // Por defecto el usuario creado por un admin debe cambiar su contraseña
    // en el primer login (la temporal solo la conoce quien lo creó).
    mustChangePassword: z.boolean().optional().default(true),
});
export const updateUserSchema = z.object({
    fullName: z.string().min(1).max(150).optional(),
    status: userStatusEnum.optional(),
    roles: z.array(z.string()).optional(),
    ginaIdcompany: z.number().int().positive().nullable().optional(),
});
export const resetPasswordSchema = z.object({
    newPassword: z.string().min(12).max(255),
});
//# sourceMappingURL=user.js.map